module.exports = __webpack_public_path__ + "img/icon-cooperater-empty.c1c316cf.png";